export const ACCENT  = "#7C6FFF";
export const ACCENT2 = "#FF6B9D";
export const DARK    = "#080B18";
export const TEXT    = "#F0EEF8";
export const MUTED   = "rgba(240,238,248,0.5)";
export const BORDER  = "rgba(255,255,255,0.08)";
export const CARD_BG = "rgba(255,255,255,0.04)";

export const CARD_COLORS = [
  { id: "lavender", hex: "#e1c2e9", label: "Lavender" },
  { id: "mint",     hex: "#ccefef", label: "Mint"     },
  { id: "lime",     hex: "#def8c3", label: "Lime"     },
  { id: "peach",    hex: "#ffd8bb", label: "Peach"    },
  { id: "yellow",   hex: "#ede796", label: "Yellow"   },
];

export const DEFAULT_PRICE = 199;

/* Firestore doc that stores the live price:
   Collection: "settings"  Document: "pricing"  Field: "cardPrice" (number)
   Admin writes it → App reads it on mount → price flows everywhere */
export const PRICE_DOC_PATH = { col: "settings", docId: "pricing", field: "cardPrice" };

export const STATUS_FLOW = ["paid", "qr_generated", "printing", "shipped", "delivered"];
export const STATUS_META = {
  paid:         { label: "💳 Paid",       color: "#f5c460", bg: "rgba(239,159,39,0.2)"  },
  qr_generated: { label: "✅ QR Done",    color: "#9fd45a", bg: "rgba(99,153,34,0.2)"   },
  printing:     { label: "🖨 Printing",   color: "#85b7eb", bg: "rgba(55,138,221,0.2)"  },
  shipped:      { label: "🚚 Shipped",    color: "#a89fff", bg: "rgba(124,111,255,0.2)" },
  delivered:    { label: "📦 Delivered",  color: "#5dcaa5", bg: "rgba(29,158,117,0.2)"  },
  pending:      { label: "⏳ Pending",    color: "#f5c460", bg: "rgba(239,159,39,0.15)" },
};
export const getStatusMeta = (s) => STATUS_META[s] || STATUS_META.pending;

export const generateMemberId = () => {
  const year   = new Date().getFullYear();
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `RQ-${year}-${random}`;
};

export const EMPTY_CARD = () => ({
  _id: `${Date.now()}-${Math.random()}`,
  name: "", photo: "", gender: "", dob: "", address: "",
  shippingAddress: "", pincode: "", phone: "",
  diabetes: "", bloodPressure: "", bloodGroup: "",
  ec1Name: "", ec1Phone: "",
  ec2Name: "", ec2Phone: "",
  ec3Name: "", ec3Phone: "",
  cardColor: "lavender",
  accepted: false,
});
